/**
 * @voltxampere/ui — FT232RL USB-UART bridge variant (Sprint 49-6)
 *
 * FTDI's classic USB-to-UART converter (28-pin SSOP). Used in
 * Arduino Diecimila / Duemilanove, generic USB programming cables.
 * Internal USB-host logic Sprint 51+.
 *
 * Reference: FTDI FT232RL datasheet (FT_000054 v2.13, 2018).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * for VCC rail; UART RX/TX wired separately as digital lines.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const icFt232rl = {
    id: "ft232rl",
    nameTr: "FT232RL (USB-UART Köprü)",
    nameEn: "FT232RL (USB-UART Bridge)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "FT232RL",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 5.0,
        busType: "usb-uart",
        vendor: "FTDI",
        package: "SSOP-28",
        maxBaudRate: 3_000_000,
        hasModemControl: true, // RTS/CTS/DTR/DSR/DCD/RI
        voltageRangeV: { min: 1.8, max: 5.25 },
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=ic-ft232rl.js.map